
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import SpecialsScreen from './specials';

function Index({dishs, SetshowExecutiveMenu}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

    const [showSpecials, setShowSpecials] = useState(false);

    
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={true} setShowListProduct={SetshowExecutiveMenu}  setShowSpecials={setShowSpecials}>
                <div  style={{padding: '0 20px'}}>
                     <img
                        src={require('./assets/top.png')}
                        style={{
                        objectFit: 'contain',
                        width: '100%',
                        height: 140,
                        marginTop: -10,
                        }}
                    />
                    <img
                        src={require('./assets/imageexcutive.png')}
                        style={{
                        width: '100%',
                        height: 550,
                        objectFit: 'contain',
                        borderRadius: 20,
                        }}
                    />
                </div>
                
                 {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={SetshowExecutiveMenu}/>}
            </LayoutContent>
        </div>
    );
}
export default Index;